import "./initialsTile.css";

/**
 * Somebody's initials in a square tile.
 *
 * The fifth copy of this, extracted — `activity.css` has been carrying the note
 * that it was worth doing since the audit log landed. What made it worth doing
 * now is not the duplication: it is that every copy hard-coded --brand-tint, so
 * an agent's rail rendered its tiles in the COLLECTOR's red wash inside a pink
 * portal. One component reading --accent-tint fixes all of them at once, and a
 * sixth portal cannot get it wrong.
 *
 * Square, not a circle. Every other corner in ONDO is square, and the circle was
 * the one place the shell disagreed with itself.
 *
 * `aria-hidden`, always: the initials are a compression of a name that is
 * ALREADY beside them in full, so announcing "M H" before "Michael Hue-Williams"
 * reads it twice and the first time is gibberish. A caller that has no visible
 * name beside the tile should not be using one.
 */
export function InitialsTile({
  initials,
  className,
}: {
  initials: string;
  /** The caller's own class, for size and placement only. Colour comes from here. */
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={className ? `initials-tile ${className}` : "initials-tile"}
    >
      {initials}
    </span>
  );
}
